import React from 'react';
import { Link } from 'react-router-dom';
import useProfileStatus from '../hooks/useProfileStatus';

const ProfileCompletionBanner = () => {
  const { isProfileComplete, isLoading } = useProfileStatus();

  // Don't show banner if loading or profile is complete
  if (isLoading || isProfileComplete) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-yellow-700">
            <strong>Complete your profile</strong> to get the most out of Civix. 
            Add your name, email, and location to start reporting issues and engaging with your community.
          </p>
        </div>
        <div className="ml-4 flex-shrink-0">
          <Link
            to="/profile-setup"
            className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-yellow-800 bg-yellow-100 hover:bg-yellow-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors duration-200"
          >
            Complete Profile
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionBanner;

